export const dialogTitleTheme = {
  root: {
    padding: '16px 24px',
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
}

export const dialogActionsTheme = {
  root: {
    padding: '16px 24px 24px',
  },
}
